import request from '@/utils/request'

/**
 * 获取诊所, 集团信息
 * @param {*} id
 * @returns
 */
export const getClinicInfo = (params) => {
  return request({
    url: '/sys/v1/clinicInfo/findClinicInfo',
    params
  })
}

/**
 * 新增或者修改  诊所, 集团信息
 * @param {*} data
 * @returns
 */
export const postClinicInfo = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/clinicInfo',
    data
  })
}

/**
 * 根据租户id查询诊所列表
 * @param {*} params
 * @returns
 */
export const getClinicsByTenantId = (params) => {
  return request({
    url: '/sys/v1/enterprise/page',
    params
  })
}

/**
 * 同步诊所域
 * @param {*} clinicId
 */
export const asyncClinicDomain = (clinicId) => {
  return request({
    url: `/tools/v1/enterprise/syncClinicDomain/${clinicId}`
  })
}
